import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const getAllMlsTypes = async () => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: '/rets/mls_types',
  };

  const { data } = await axios.request<string[]>(config);

  return data;
};

export default getAllMlsTypes;
